import React from 'react';
import { IconButton, Menu, MenuItem } from '@mui/material';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import LogoutIcon from '@mui/icons-material/Logout';
import { useUser } from '@/context/UserContext';

const Profile: React.FC = () => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  const { signOut } = useUser();
  const handleSignOut = async () => {
    try {
      await signOut();
    } catch (error) {
      console.error('Sign out failed:', error);
    }
    handleClose();
  };

  return (
    <>
      <IconButton
        size="large"
        edge="end"
        aria-label="profile"
        aria-controls="profile-menu"
        aria-haspopup="true"
        onClick={handleMenu}
        color="inherit"
      >
        <AccountCircleIcon />
      </IconButton>
      <Menu
        id="profile-menu"
        anchorEl={anchorEl}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        keepMounted
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        open={open}
        onClose={handleClose}
        sx={{ 
          '& .MuiPaper-root': { minHeight: 'auto' },
          '& .MuiList-root': { paddingTop: '2px', paddingBottom: '2px' }
        }}
      >
        <MenuItem onClick={handleSignOut} sx={{ fontSize: '0.875rem', padding: '4px 12px', minHeight: 'auto' }}>
          <LogoutIcon fontSize="small" style={{ marginRight: 8 }} /> Sign Out
        </MenuItem>
      </Menu>
    </>
  );
};

export default Profile;